import type { GraphRendererPlugin } from './GraphRendererPlugin';

const ZOOM_SPEED = 0.2;

export const zoom: GraphRendererPlugin = (pluginInterface) => {
  const { viewport } = pluginInterface;

  const zoomIn = () => {
    const newScale = viewport.scale.x * (1 + ZOOM_SPEED);
    viewport.setZoom(newScale, true);
  };

  const zoomOut = () => {
    const newScale = viewport.scale.x * (1 - ZOOM_SPEED);
    viewport.setZoom(newScale, true);
  };

  pluginInterface.events.addListener('zoomIn', zoomIn);
  pluginInterface.events.addListener('zoomOut', zoomOut);
};
